export function getVisibleUrl(url: string): string {
	try {
		const parsedUrl = new URL(url);
		return `${parsedUrl.host}${parsedUrl.pathname}`;
	} catch {
		return url;
	}
}
